import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, input } from '@angular/core';

import { ImgPlaceholderPipe } from '@coworkrz/shared/misc';

@Component({
  selector: 'ui-slider',
  imports: [CommonModule, ImgPlaceholderPipe],
  templateUrl: './slider.component.html',
})
export class SliderComponent implements OnInit, OnDestroy {
  readonly showSlideButton = input(false);
  readonly startSlider = input(true);
  readonly images = input<string[]>([]);
  @Input() title: string;
  @Input() description: string | null;
  showImageIndex: boolean;

  interval: any;
  currentImageIndex = 0;

  ngOnInit(): void {
    if (this.startSlider()) this.startImageSlider();
    this.showImageIndex = this.images().length > 1;
  }

  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval);
  }

  startImageSlider(): void {
    this.interval = setInterval(() => {
      this.currentImageIndex =
        (this.currentImageIndex + 1) % this.images().length;
    }, 3000); // Change image every 3 seconds
  }

  resetInterval(): void {
    clearInterval(this.interval);
    if (this.startSlider()) this.startImageSlider();
  }

  slideRight(): void {
    if (this.currentImageIndex == this.images().length - 1)
      this.currentImageIndex = 0;
    else this.currentImageIndex++;
    this.resetInterval();
  }

  slideLeft(): void {
    if (this.currentImageIndex == 0)
      this.currentImageIndex = this.images().length - 1;
    else this.currentImageIndex--;
    this.resetInterval();
  }
}
